import { AnnouncementsFacade } from './announcements.facade';
import { NewsFacade } from './news.facade';
import { OffersFacade } from './offers.facade';

export * from './announcements.facade';
export * from './news.facade';
export * from './offers.facade';

export const NEWS_FACADES = [AnnouncementsFacade, NewsFacade, OffersFacade];
